export class SispacError {

  message;

  constructor(public originalError: any) {
    this.message = originalError.error;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/errors/sispac-error.ts